import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IonRouterOutlet } from '@ionic/angular'
import { LogEvent, LoginType } from 'src/app/interfaces/log'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'
import { RouterService } from 'src/app/services/router/router.service'
import { UserService } from 'src/app/services/user/user.service'
import { Header } from './header'

/**
 * deprecated
 */

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends Header {
  @Input() title = ''
  @Input() titleImage = ''
  @Input() type: 'gnb' | 'default' = 'default'
  @Input() onBackButton?: () => void
  @Input() showLogo = false // 로고 여부 (backbutton은 안보여줌) - only for web
  @Input() showMenu = false // 메뉴 버튼 활성화 여부 - only for web
  // defaultA: 로고 + 메뉴 , defaultB: 백버튼
  @Input() webType: 'defaultA' | 'defaultB' | undefined
  @Input() hideLoginButton = false
  @Output() submitClick = new EventEmitter<void>()

  constructor(
    public userService: UserService,
    protected generalService: GeneralService,
    protected logService: LogService,
    private routerService: RouterService,
    private routerOutlet: IonRouterOutlet
  ) {
    super(generalService, logService)
  }

  get isLoggedIn(): boolean {
    return this.userService.isLoggedIn
  }

  /**
   * 앱일 경우 무조건 false
   * defaultA 타입일 경우 로고와 메뉴 보이기
   */
  get showLogoIcon(): boolean {
    if (!this.generalService.isApp && this.webType === 'defaultA') {
      return true
    }
    return this.showLogo
  }

  /**
   * 앱일 경우 무조건 false
   * defaultA 타입일 경우 로고와 메뉴 보이기
   */
  get showMenuIcon(): boolean {
    if (this.isApp) {
      return false
    }
    if (this.webType === 'defaultA') {
      return true
    }
    return this.showMenu
  }

  onClickBackButton(): void {
    if (this.onBackButton !== undefined) {
      this.onBackButton()
    } else {
      this.routerService.navigateBack(this.routerOutlet)
    }
  }

  onClickLogin(): void {
    if (!this.isLoggedIn) {
      this.routerService.navigate('login', { queryParams: { type: LoginType.HEADER } })
      this.logService.eventLogging(LogEvent.ENTER_LOGIN)
    }
  }

  onClickLogo(): void {
    this.logService.eventLogging(LogEvent.HEADER_LOGO_CLICKED, { from: location.pathname })
    this.routerService.navigate('gnb/main')
  }
}
